// extracted by mini-css-extract-plugin
export var dataCell = "_m4-2";
export var dataRow = "_m4-0";
export var headerRow = "_m4-1";